module.exports = __webpack_public_path__ + "static/img/03.e290eb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/store/03.jpg
// module id = Ezyk
// module chunks = 0